import { type InputWrapperProps, Menu } from "@mantine/core";
import { RichTextEditor, useRichTextEditorContext } from "@mantine/tiptap";
import { IconPuzzle } from "@tabler/icons-react";
import { PreviewFormEditor } from "../editor/PreviewFormEditor";
import { PlaceholderGroup } from "./EmailEditorForm";

type EmailEditorProps = InputWrapperProps & {
  defaultValue?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPreview: () => void;
  previewText?: string;
  disabled?: boolean;
  showPlaceholderGroups?: PlaceholderGroup;
};

export function EmailEditor({ disabled, showPlaceholderGroups, ...props }: EmailEditorProps) {
  return (
    <PreviewFormEditor disabled={disabled} {...props}>
      <RichTextEditor.ControlsGroup>
        {showPlaceholderGroups === PlaceholderGroup.None || <TemplateControl showPlaceholderGroups={showPlaceholderGroups} />}
      </RichTextEditor.ControlsGroup>
    </PreviewFormEditor>
  );
}

function TemplateControl({ showPlaceholderGroups }: { showPlaceholderGroups?: PlaceholderGroup }) {
  const { editor } = useRichTextEditorContext();
  const showPlaceholderGroup = (placeholderGroup: PlaceholderGroup) =>
    showPlaceholderGroups && (showPlaceholderGroups & placeholderGroup) === placeholderGroup;

  return (
    <RichTextEditor.Control aria-label="Textbaustein" title="Textbaustein">
      <Menu>
        <Menu.Target>
          <IconPuzzle stroke={1} />
        </Menu.Target>
        <Menu.Dropdown>
          {showPlaceholderGroup(PlaceholderGroup.Receiver) && (
            <Menu.Sub>
              <Menu.Sub.Target>
                <Menu.Sub.Item>Empfänger</Menu.Sub.Item>
              </Menu.Sub.Target>
              <Menu.Sub.Dropdown>
                <Menu.Item onClick={() => editor?.commands.insertContent("$salutation ")}>Ansprache</Menu.Item>
                <Menu.Item onClick={() => editor?.commands.insertContent("$full_name ")}>Name</Menu.Item>
                <Menu.Item onClick={() => editor?.commands.insertContent("$first_name ")}>Vorname</Menu.Item>
                <Menu.Item onClick={() => editor?.commands.insertContent("$last_name ")}>Nachname</Menu.Item>
                <Menu.Item onClick={() => editor?.commands.insertContent("$date ")}>Absende Datum</Menu.Item>
              </Menu.Sub.Dropdown>
            </Menu.Sub>
          )}
          {showPlaceholderGroup(PlaceholderGroup.Apprentice) && (
            <Menu.Sub>
              <Menu.Sub.Target>
                <Menu.Sub.Item>Lernende/r</Menu.Sub.Item>
              </Menu.Sub.Target>
              <Menu.Sub.Dropdown>
                <Menu.Item onClick={() => editor?.commands.insertContent("$ll_full_name ")}>Name</Menu.Item>
                <Menu.Item onClick={() => editor?.commands.insertContent("$ll_first_name ")}>Vorname</Menu.Item>
                <Menu.Item onClick={() => editor?.commands.insertContent("$ll_last_name ")}>Nachname</Menu.Item>
              </Menu.Sub.Dropdown>
            </Menu.Sub>
          )}
          {showPlaceholderGroup(PlaceholderGroup.Group) && (
            <Menu.Sub>
              <Menu.Sub.Target>
                <Menu.Sub.Item>Gruppe</Menu.Sub.Item>
              </Menu.Sub.Target>
              <Menu.Sub.Dropdown>
                <Menu.Item onClick={() => editor?.commands.insertContent("$group_name ")}>Name</Menu.Item>
                <Menu.Item onClick={() => editor?.commands.insertContent("$coach_full_name ")}>Coach Name</Menu.Item>
              </Menu.Sub.Dropdown>
            </Menu.Sub>
          )}
          {showPlaceholderGroup(PlaceholderGroup.Document) && (
            <Menu.Sub>
              <Menu.Sub.Target>
                <Menu.Sub.Item>Dokument</Menu.Sub.Item>
              </Menu.Sub.Target>
              <Menu.Sub.Dropdown>
                <Menu.Item onClick={() => editor?.commands.insertContent("$document_link ")}>Dokument Link</Menu.Item>
              </Menu.Sub.Dropdown>
            </Menu.Sub>
          )}
        </Menu.Dropdown>
      </Menu>
    </RichTextEditor.Control>
  );
}
